import React, { useEffect } from 'react';
import QRCode from 'qrcode.react';

import { useSession } from '../../providers/SessionProvider';
import { REACT_APP_AWS_BUCKET_PATH } from '../../utils/config';
import ContentHeader from '../../components/ContentHeader';
import Footer from '../../components/Footer';
import MainHeader from '../../components/MainHeader';
import SideMenu from '../../components/SideMenu';

function AgentImage({ agent }) {
  return (
    <img
      src={
        agent.profile_image
          ? `${REACT_APP_AWS_BUCKET_PATH}/uploads/agents/images/${agent.profile_image}`
          : 'https://via.placeholder.com/150'
      }
      alt={agent.name}
    />
  );
}

function Home() {
  const { agent, setIsAssessoryMenuSelected } = useSession();

  useEffect(() => {
    setIsAssessoryMenuSelected(false);
  }, []);

  return (
    <div className="interna gray">
      <div className="white" />
      <div className="container bug-height">
        <div className="row first-row">
          <div className="col grid_3 left-menu">
            <MainHeader />
            <SideMenu />
          </div>
          <div className="col grid_9 content">
            <ContentHeader />
            <h3>Carteira Certificado ABAF</h3>
            <div className="card">
              <div className="row gutters">
                <div className="col grid_3">
                  <i className="foto">
                    <AgentImage agent={agent} />
                  </i>
                </div>
                <div className="col grid_9">
                  <div className="name">
                    {agent.name} <span>Agente Oficial ABAF</span>
                  </div>
                </div>
              </div>
              <div className="row dados">
                <div className="col grid_8">
                  <div className="card-contact">
                    <p>
                      <i>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17.42"
                          height="13.065"
                          viewBox="0 0 17.42 13.065"
                        >
                          <path
                            id="iconfinder_contact_126567"
                            d="M8.71,10.71a2.525,2.525,0,0,1-1.089-.366L0,6.355v7.621a1.092,1.092,0,0,0,1.089,1.089H16.331a1.092,1.092,0,0,0,1.089-1.089V6.355L9.8,10.344A2.525,2.525,0,0,1,8.71,10.71ZM16.331,2H1.089A1.092,1.092,0,0,0,0,3.089v.825L8.71,8.492l8.71-4.578V3.089A1.092,1.092,0,0,0,16.331,2Z"
                            transform="translate(0 -2)"
                            fill="#ffc400"
                          />
                        </svg>
                      </i>
                      {agent.email}
                    </p>

                    {agent.website && (
                      <p>
                        <i>
                          <svg
                            id="internet"
                            xmlns="http://www.w3.org/2000/svg"
                            width="16.156"
                            height="16.764"
                            viewBox="0 0 16.156 16.764"
                          >
                            <g id="Group_3166" data-name="Group 3166">
                              <path
                                id="Path_2929"
                                data-name="Path 2929"
                                d="M8.078,0A8.252,8.252,0,0,0,0,8.382a8.252,8.252,0,0,0,8.078,8.382,8.252,8.252,0,0,0,8.078-8.382A8.252,8.252,0,0,0,8.078,0ZM5.669,1.417A8.445,8.445,0,0,0,4.433,3.929H2.386A7.189,7.189,0,0,1,5.669,1.417ZM1.781,4.908H4.165a15.4,15.4,0,0,0-.371,2.983H.963A7.571,7.571,0,0,1,1.781,4.908Zm0,6.945a7.555,7.555,0,0,1-.819-2.98H3.794a15.366,15.366,0,0,0,.371,2.98Zm.6.982H4.433a8.446,8.446,0,0,0,1.236,2.512A7.189,7.189,0,0,1,2.386,12.835ZM7.6,15.7c-1.057-.369-1.785-1.776-2.17-2.863H7.6Zm0-3.846H5.14a14.131,14.131,0,0,1-.4-2.98H7.6Zm0-3.962H4.741a14.135,14.135,0,0,1,.4-2.98H7.6Zm0-3.962H5.435C5.819,2.842,6.548,1.434,7.6,1.066Zm6.77.982a7.555,7.555,0,0,1,.819,2.98H12.362a15.366,15.366,0,0,0-.371-2.98Zm-.6-.982H11.724a8.446,8.446,0,0,0-1.236-2.512A7.189,7.189,0,0,1,13.77,3.929ZM8.552,1.066c1.057.369,1.785,1.776,2.17,2.863H8.552Zm0,3.846h2.465a14.131,14.131,0,0,1,.4,2.98H8.552Zm0,3.958h2.864a14.167,14.167,0,0,1-.4,2.983H8.552Zm0,6.828V12.832h2.17C10.337,13.919,9.608,15.33,8.552,15.7Zm1.936-.352a8.464,8.464,0,0,0,1.236-2.515H13.77A7.2,7.2,0,0,1,10.488,15.346Zm3.887-3.494H11.991a15.4,15.4,0,0,0,.371-2.983h2.831A7.571,7.571,0,0,1,14.375,11.853Z"
                                fill="#ffc400"
                              />
                            </g>
                          </svg>
                        </i>
                        {agent.website}
                      </p>
                    )}

                    {agent.cellphone && (
                      <p>
                        <i>
                          <svg
                            id="Page-1"
                            xmlns="http://www.w3.org/2000/svg"
                            width="14.544"
                            height="14.544"
                            viewBox="0 0 14.544 14.544"
                          >
                            <g id="Icons-Communication">
                              <g id="phone">
                                <path
                                  id="Shape"
                                  d="M2.909,6.3a12.579,12.579,0,0,0,5.333,5.333l1.778-1.778a.643.643,0,0,1,.808-.162,8.452,8.452,0,0,0,2.909.485.763.763,0,0,1,.808.808v2.747a.763.763,0,0,1-.808.808A13.725,13.725,0,0,1,0,.808.763.763,0,0,1,.808,0H3.636a.763.763,0,0,1,.808.808,9.151,9.151,0,0,0,.485,2.909,1,1,0,0,1-.162.808L2.909,6.3Z"
                                  transform="translate(0)"
                                  fill="#ffc400"
                                  fillRule="evenodd"
                                />
                              </g>
                            </g>
                          </svg>
                        </i>
                        {agent.cellphone}
                      </p>
                    )}
                  </div>
                </div>
                <div className="col grid_4">
                  <div className="qr-code">
                    <QRCode
                      size={120}
                      value={`https://abaf-c2f4f.web.app/agentes/${agent.slug}`}
                      renderAs="svg"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Home;
